$(() => {
  $pop_line = $('.section-fv__line')

  $(window).on('load scroll', function() {
    if(window.scrollY + window.innerHeight >= $('footer').offset().top) {
      $pop_line.fadeOut()
    }else {
      $pop_line.fadeIn()
    }
  })
});
